/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Typography, Box, Grid, useTheme, useMediaQuery } from "@mui/material";
//import man from "assets/images/man.png";
import manface from "assets/images/manface.png";
import FooterView from "components/FooterView";
import { handleBGColor } from "pages/home/CommonFunctions";

const AboutUs = (props) => {
  const theme = useTheme();
  //const isSmallScreen = useMediaQuery("(max-width:1000px)");
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const {
    organizationInfo: { app, colorSchemeJson, organizationOptionJson },
  } = props;
  //const isShowBackgroundAssets = showBackgroundAssetsFlag?.toUpperCase() === "Y";

  useEffect(() => {
    props.setValue(3);
    document.getElementById("appcontent").scroll(0, 0);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginRight: "auto",
        marginLeft: "auto",
      }}
    >
      <Helmet>
        <title>
          About us | {app?.appCode === "CVD" ? "Cuverd® Partner" : "Cuverd®"}
        </title>
        <meta
          name="description"
          content="The About us for using the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta property="og:title" content="About us | Cuverd®" />
        <meta
          property="og:description"
          content="The About us for using the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta
          property="og:image"
          content="assets/images/cuverd-logo-header.png"
        />
        <link
          rel="alternate"
          href="https://www.cuverd.com/terms-and-conditions"
          hrefLang="en-us"
        />
        <link
          rel="canonical"
          href="https://www.cuverd.com/terms-and-conditions"
        />
      </Helmet>
      <Box
        sx={{
          marginBottom: "24px",
          marginTop: matches ? "16px" : "120px",
          paddingLeft: matches ? "16px" : "160px",
          paddingRight: matches ? "16px" : "160px",
        }}
      >
        <Box sx={{ width: matchesMinWidth ? "100%" : "50%" }}>
          <Typography
            sx={{ fontSize: matchesMinWidth ? undefined : "44px" }}
            variant="h1LatoRegular"
          >
            WE'LL ALWAYS HAVE YOU CUVERD{" "}
          </Typography>
        </Box>
        <Box
          sx={{ marginTop: "30px", width: matchesMinWidth ? "100%" : "50%" }}
        >
          <Typography
            sx={{ lineHeight: "1.8", color: "#635E5E" }}
            variant={matchesMinWidth ? "h4LatoRegular" : "h1LatoRegular"}
          >
            We are a company that believes in TRANSPARENCY. We believe that you
            have the right to know exactly how much your prescription will cost
            so there are never surprises when you get to the pharmacy.
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor:
            app?.appCode !== "CVD"
              ? `${colorSchemeJson?.defaultColorScheme?.backgroundColor}  !important`
              : handleBGColor(app?.appCode),
          display: "flex",
          flexDirection: matchesMinWidth ? "column" : "row",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: matches ? "16px" : "160px",
          paddingRight: matches ? "16px" : "160px",
          paddingTop: matches ? "16px" : "0",
          paddingBottom: matches ? "16px" : "0",
        }}
      >
        <Box sx={{ width: matchesMinWidth ? "100%" : "50%", color: "#fff" }}>
          <Box>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontFamily: "Lato-Regular",
                fontSize: matchesMinWidth ? "24px" : "30px",
                marginBottom: "26px",
                color: `${colorSchemeJson?.defaultColorScheme?.textColor}`,
              }}
            >
              Get that Cuverd feeling
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                color: `${colorSchemeJson?.defaultColorScheme?.textColor}`,
                lineHeight: "36px",
                fontWeight: "700",
                //opacity: !isShowBackgroundAssets ? 0.5 : 1,
                fontSize: matchesMinWidth ? "11px" : matches ? "15px" : "22px",
              }}
              variant={matchesMinWidth ? "h1LatoSemiBold" : "h2LatoSemiBold"}
              dangerouslySetInnerHTML={{
                __html: organizationOptionJson?.appDescription,
              }}
            ></Typography>
          </Box>
          <br />
          <Box>
            <Typography
              sx={{
                color: `${colorSchemeJson?.defaultColorScheme?.textColor}`,
                lineHeight: "2",
                //opacity: !isShowBackgroundAssets ? 0.5 : 1,
              }}
              variant={matchesMinWidth ? "h1LatoSemiBold" : "h2LatoSemiBold"}
            >
              Cuverd is designed to quickly show you the lowest price for your
              medication in an easy-to-read, side-by-side comparison.
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{ width: matchesMinWidth ? "100%" : "50%", textAlign: "center" }}
        >
          <img src={manface} alt="man" style={{ width: "100%" }} />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: matches ? "16px" : "160px",
          paddingRight: matches ? "16px" : "160px",
          marginBottom: matches ? "32px" : "64px",
        }}
      >
        <Box
          sx={{
            width: matchesMinWidth ? "100%" : "50%",
            marginTop: matches ? "60px" : "120px",
            paddingTop: matches ? "16px" : "32px",
            marginBottom: "30px",
          }}
        >
          <Typography
            sx={{
              textTransform: "uppercase",
              fontWeight: "400",
              fontSize: matches ? "22px" : "44px",
            }}
            variant="h1LatoRegular"
          >
            Cuverd is a technology that SEARCHES smarter
          </Typography>
        </Box>
        <Box sx={{ width: matchesMinWidth ? "100%" : "50%" }}>
          <Typography
            sx={{ lineHeight: "1.8", color: "#635E5E" }}
            variant={matchesMinWidth ? "h4LatoRegular" : "h1LatoRegular"}
          >
            Cuverd{" "}
            {app?.appCode?.toLowerCase() !== "wgn" &&
              "is accepted at over 70,000 pharmacies nationwide and "}
            is easy to use: all you have to do is show your pharmacist your
            coupon on the Cuverd website when you pick up your prescription.
          </Typography>
        </Box>
      </Box>
      <Grid item container>
        <FooterView />
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data || {},
  };
};

export default connect(mapStateToProps)(AboutUs);
